import React from 'react';
import { Global } from '@emotion/react';

import { GlobalStyling } from './GlobalStyle.styles';

export const GlobalStyle = () => <Global styles={GlobalStyling} />;
